<div class="relative w-full h-full bg-slate-50 flex flex-col overflow-auto font-prompt pb-28 custom-scrollbar">

  <!-- 1. Header Bar (Dark Gradient VIP Theme) -->
  <div
    class="relative bg-gradient-to-b from-[#2e2f38] to-[#1a1b20] pt-6 pb-9 rounded-b-[2.5rem] shadow-lg z-20 shrink-0 text-white border-b border-white/5">

    <!-- Header Top Row -->
    <div class="flex justify-between items-center px-6 mb-5 select-none">
      <div class="flex items-center gap-3">
        <!-- Back Button -->
        <button
          class="w-9 h-9 bg-slate-100 hover:bg-slate-200/80 shadow-sm rounded-full flex justify-center items-center active:scale-95 transition-all border border-slate-200/10 text-slate-700 outline-none"
          (click)="goback()">
          <img src="icons/arrow_back_black.svg" class="w-full h-full" />
        </button>

        <h1 class="text-amber-500 text-lg font-black tracking-wide leading-none">
          {{ currentLang === "TH" ? "ใบค้างชำระการชาร์จ EV" : "EV Charging Invoices" }}
        </h1>
      </div>

      <!-- Refresh Button -->
      <button (click)="getCityParkingInvoiceInfo()"
        class="w-9 h-9 bg-slate-100 hover:bg-slate-200/80 shadow-sm rounded-full flex items-center justify-center active:scale-95 transition-all border border-slate-200/10 text-slate-700 outline-none"
        title="Refresh">
        <img src="icons/sync_black_soft.svg" />
      </button>
    </div>

    <!-- 2. Summary KPI Stats Banner (Floating Shadow style) -->
    <div class="mx-6 grid grid-cols-2 gap-3.5">
      <!-- Total Unpaid Amount Card -->
      <div
        class="bg-white rounded-2xl p-3.5 border border-slate-100 shadow-md flex items-center gap-3.5 transition-transform duration-300 active:scale-[0.98]">
        <div
          class="w-10 h-10 p-2 rounded-xl bg-rose-50 flex items-center justify-center shrink-0 border border-rose-100/50">
          <img src="icons/payments_red.svg" class="w-full h-full" />
        </div>
        <div class="min-w-0 text-left">
          <span class="text-[9px] font-black text-slate-400 block uppercase tracking-wider leading-none">
            {{ currentLang === "TH" ? "ยอดค้างชำระรวม" : "Total Unpaid" }}
          </span>
          <span class="text-base font-black text-rose-600 truncate block leading-tight mt-1.5">
            {{ totalPendingAmount | number: "1.2-2" }} <span class="text-xs font-bold">฿</span>
          </span>
        </div>
      </div>

      <!-- Pending Invoices Count Card -->
      <div
        class="bg-white rounded-2xl p-3.5 border border-slate-100 shadow-md flex items-center gap-3.5 transition-transform duration-300 active:scale-[0.98]">
        <div
          class="w-10 h-10 p-2 rounded-xl bg-amber-50 flex items-center justify-center shrink-0 border border-amber-100/50">
          <img src="icons/receipt_long_orange.svg" class="w-full h-full" />
        </div>
        <div class="min-w-0 text-left">
          <span class="text-[9px] font-black text-slate-400 block uppercase tracking-wider leading-none">
            {{ currentLang === "TH" ? "จำนวนใบค้างชำระ" : "Pending Invoices" }}
          </span>
          <span class="text-base font-black text-slate-800 truncate block leading-tight mt-1.5">
            {{ invoiceList.length }} <span class="text-xs font-bold text-slate-500">{{ currentLang === "TH" ? "รายการ" :
              "items" }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- 3. Search Bar -->
  <div class="px-6 -mt-3.5 z-30 relative">
    <div class="bg-white rounded-2xl shadow-sm border border-slate-100 p-2 flex items-center gap-2">
      <div class="pl-2 text-slate-400">
        <img src="icons/search_slate.svg" />
      </div>
      <input type="text" [(ngModel)]="searchText"
        placeholder="{{ currentLang === 'TH' ? 'ค้นหาใบค้างชำระ, ทะเบียน หรือสถานที่...' : 'Search invoice, plate, or site...' }}"
        class="w-full h-8 bg-transparent focus:outline-none text-slate-700 placeholder-slate-400 text-xs font-bold border-none" />
      <button *ngIf="searchText" (click)="onClearSearch()"
        class="w-7 h-7 flex items-center justify-center bg-slate-50 hover:bg-slate-100 rounded-lg text-slate-400 active:scale-95 transition-all outline-none border-none cursor-pointer">
        <img src="icons/close_slate_dark.svg" class="w-full h-full" />
      </button>
    </div>
  </div>

  <!-- 4. Scrollable Invoice List -->
  <div class="flex-1 px-6 pb-28 space-y-3.5 mt-5">

    <!-- Invoice Cards Loop -->
    <div *ngFor="let invoice of filteredInvoices"
      class="bg-white rounded-3xl p-4.5 shadow-sm border border-slate-100 relative group active:scale-[0.99] transition-all hover:shadow-md cursor-pointer flex flex-col gap-3 text-left">

      <!-- Top Card Header: Location & Status Badge -->
      <div class="flex items-center justify-between gap-2 pb-2.5 border-b border-slate-100">
        <div class="flex items-center gap-2 min-w-0">
          <div class="w-8 h-8 p-1.5 rounded-xl bg-amber-50 flex items-center justify-center shrink-0">
            <img src="icons/electric_car_orange.svg" class="w-full h-full" />
          </div>
          <div class="min-w-0">
            <span class="text-xs font-black text-slate-800 block truncate">{{ invoice.siteName || "Paragon" }}</span>
            <div class="flex items-center gap-1.5 mt-0.5">
              <span
                class="text-[9px] font-bold text-amber-700 bg-amber-50 border border-amber-100/50 px-2 py-0.5 rounded-md">
                {{ currentLang === "TH" ? "ตู้ชาร์จ:" : "Slot:" }} {{ invoice.siteEv || invoice.spaceCode || "--" }}
              </span>
            </div>
          </div>
        </div>

        <span
          class="px-2.5 py-1 rounded-full text-[9px] font-black bg-rose-50 text-rose-600 border border-rose-100 shrink-0">
          {{ currentLang === "TH" ? "ค้างชำระ" : "Unpaid" }}
        </span>
      </div>

      <!-- Card Body Info -->
      <div class="grid grid-cols-2 gap-3 text-xs">
        <div>
          <span class="text-[9px] font-black text-slate-400 uppercase tracking-wider block mb-0.5">
            {{ currentLang === "TH" ? "เลขที่ใบค้างชำระ" : "Invoice No." }}
          </span>
          <span class="font-mono text-slate-700 font-bold block truncate">
            {{ invoice.spaceCode ? invoice.spaceCode + '-EV' : invoice.name }}
          </span>
        </div>

        <div>
          <span class="text-[9px] font-black text-slate-400 uppercase tracking-wider block mb-0.5">
            {{ currentLang === "TH" ? "ทะเบียนรถ" : "License Plate" }}
          </span>
          <span
            class="font-bold text-slate-800 inline-flex items-center gap-1 bg-slate-50 px-2 py-0.5 rounded-lg border border-slate-100">
            <img src="icons/directions_car_slate_dark.svg" class="w-3.5 h-3.5" />
            {{ invoice.licensePlate || "--" }}
          </span>
        </div>
      </div>

      <!-- Time Stamps Row -->
      <div
        class="bg-slate-50/70 rounded-2xl p-3 space-y-2 text-[10px] text-slate-500 font-bold border border-slate-100/50">
        <div class="flex items-center justify-between">
          <span class="flex items-center gap-1 text-slate-400">
            <img src="icons/calendar_today_slate.svg" class="w-3.5 h-3.5" />
            {{ currentLang === "TH" ? "เวลาชาร์จ:" : "Charging Time:" }}
          </span>
          <span class="font-mono font-bold text-slate-700">
            {{ (invoice.chargingStart | date: "dd/MM/yy HH:mm") || "--" }} - {{ (invoice.chargingEnd | date: "HH:mm") ||
            "--" }}
          </span>
        </div>

        <div class="flex items-center justify-between" *ngIf="invoice.exitAt">
          <span class="flex items-center gap-1 text-slate-400">
            <img src="icons/schedule_slate.svg" class="w-3.5 h-3.5" />
            {{ currentLang === "TH" ? "เวลาออก:" : "Exit Time:" }}
          </span>
          <span class="font-mono font-bold text-slate-700">
            {{ invoice.exitAt | date: "dd/MM/yy HH:mm" }}
          </span>
        </div>
      </div>

      <!-- Card Footer: Total Amount & View Details Button -->
      <div class="mt-1 pt-2.5 border-t border-dashed border-slate-100 flex justify-between items-end">
        <div>
          <span class="text-[9px] text-slate-400 font-black block leading-none">
            {{ currentLang === "TH" ? "ยอดชำระ" : "Total Fee" }}
          </span>
          <span class="text-base font-black text-rose-600 leading-none mt-1 block">
            {{ invoice.total | number: "1.2-2" }} <span class="text-xs font-extrabold text-rose-500">฿</span>
          </span>
        </div>

        <button (click)="onClickSeeInvoice(invoice.id)"
          class="px-4 py-2.5 bg-amber-400 hover:bg-amber-500 text-slate-800 text-xs font-black rounded-xl shadow-sm active:scale-95 transition-transform flex items-center gap-1 cursor-pointer border-none outline-none">
          <img src="icons/payments_black.svg" class="w-4 h-4" />
          <span>{{ currentLang === "TH" ? "ดูรายละเอียด & ชำระเงิน" : "View & Pay" }}</span>
        </button>
      </div>

    </div>

    <!-- Empty State -->
    <div *ngIf="filteredInvoices.length === 0"
      class="flex flex-col items-center justify-center py-20 text-slate-400 select-none">
      <img class="mb-2" src="icons/ev_station_slate_dark.svg" />
      <p class="text-xs font-bold text-slate-700 mb-1">
        {{ currentLang === "TH" ? "ไม่พบรายการค้างชำระ" : "No Unpaid Invoices Found" }}
      </p>
      <p class="text-[10px] font-bold text-slate-400 max-w-xs leading-normal">
        {{ currentLang === "TH" ? "คุณไม่มีรายการค้างชำระการชาร์จรถไฟฟ้าในขณะนี้" : "You have no unpaid EV charging
        records at this time." }}
      </p>
    </div>

  </div>
</div>

<!-- ============================================ MODALS ============================================ -->

<!-- Modal 1: See Invoice Detail -->
<div *ngIf="isOpenModalInvoiceDetail"
  class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm px-4 animate-fade-in">
  <div
    class="bg-white w-full max-w-sm rounded-[2.5rem] p-6 relative animate-scale-up border border-slate-100/50 shadow-2xl space-y-4 max-h-[90vh] overflow-y-auto custom-scrollbar">

    <!-- Modal Header -->
    <div class="flex items-center justify-between pb-3 border-b border-slate-100">
      <div class="flex items-center gap-2">
        <div class="w-8 h-8 p-1.5 rounded-xl bg-amber-50 flex items-center justify-center">
          <img src="icons/receipt_long_orange.svg" class="w-full h-full" />
        </div>
        <h3 class="text-sm font-black text-slate-800">
          {{ currentLang === "TH" ? "รายละเอียดค้างชำระ" : "Invoice Details" }}
        </h3>
      </div>
      <button (click)="closeModalInvoiceDetail()"
        class="w-7 h-7 rounded-full bg-slate-50 hover:bg-slate-100 text-slate-400 flex items-center justify-center transition-colors">
        <img src="icons/close_slate_dark.svg" class="w-4 h-4" />
      </button>
    </div>

    <!-- Wallet Balance Status Banner -->
    <div class="p-3.5 rounded-2xl border transition-all flex items-center justify-between"
      [ngClass]="topupAmount.amount >= (invoiceDetail?.total || 0) ? 'bg-emerald-50/60 border-emerald-100 text-emerald-800' : 'bg-rose-50/60 border-rose-100 text-rose-800'">
      <div class="flex items-center gap-2.5">
        <img src="icons/account_balance_wallet_emerald.svg" class="w-6 h-6 shrink-0"
          *ngIf="topupAmount.amount >= (invoiceDetail?.total || 0)" />
        <img src="icons/info_red.svg" class="w-6 h-6 shrink-0"
          *ngIf="topupAmount.amount < (invoiceDetail?.total || 0)" />
        <div class="text-left">
          <span class="text-[10px] font-bold block leading-none opacity-85">
            {{ currentLang === "TH" ? "ยอดเงินคงเหลือในบัญชี" : "EV Wallet Balance" }}
          </span>
          <span class="text-xs font-black font-mono mt-1 block">
            {{ topupAmount.amount | number: "1.2-2" }} ฿
          </span>
        </div>
      </div>

      <span class="text-[9px] font-black px-2 py-0.5 rounded-full"
        [ngClass]="topupAmount.amount >= (invoiceDetail?.total || 0) ? 'bg-emerald-100 text-emerald-700' : 'bg-rose-100 text-rose-700'">
        {{ topupAmount.amount >= (invoiceDetail?.total || 0) ? (currentLang === "TH" ? "เพียงพอ" : "Sufficient") :
        (currentLang === "TH" ? "ไม่เพียงพอ" : "Insufficient") }}
      </span>
    </div>

    <!-- Detail Items Container -->
    <div class="bg-slate-50/60 rounded-2xl p-4 space-y-2.5 border border-slate-100 text-xs">
      <!-- Site Name -->
      <div class="flex justify-between items-center">
        <span class="text-slate-400 font-bold">{{ currentLang === "TH" ? "สถานที่" : "Location" }}</span>
        <span class="font-bold text-slate-800 truncate max-w-[180px]">{{ invoiceDetail?.siteName || "--" }}</span>
      </div>

      <!-- Invoice Name / Fee Name -->
      <div class="flex justify-between items-center">
        <span class="text-slate-400 font-bold">{{ currentLang === "TH" ? "ชื่อรายการ" : "Invoice Name" }}</span>
        <span class="font-bold text-slate-800">{{ invoiceDetail?.name || invoiceDetail?.feeName || "--" }}</span>
      </div>

      <!-- License Plate -->
      <div class="flex justify-between items-center">
        <span class="text-slate-400 font-bold">{{ currentLang === "TH" ? "ทะเบียนรถ" : "License Plate" }}</span>
        <span class="font-mono font-black text-slate-800 bg-white px-2 py-0.5 rounded border border-slate-200">
          {{ invoiceDetail?.licensePlate || "--" }}
        </span>
      </div>

      <!-- Divider -->
      <div class="border-t border-dashed border-slate-200 my-1"></div>

      <!-- Charge Start -->
      <div class="flex justify-between items-center">
        <span class="text-slate-400 font-bold">{{ currentLang === "TH" ? "เริ่มชาร์จ" : "Start Charge" }}</span>
        <span class="font-mono text-slate-700 font-medium">
          {{ (invoiceDetail?.chargingStart | date: "dd/MM/yyyy HH:mm") || "--" }}
        </span>
      </div>

      <!-- Charge End -->
      <div class="flex justify-between items-center">
        <span class="text-slate-400 font-bold">{{ currentLang === "TH" ? "เลิกชาร์จ" : "End Charge" }}</span>
        <span class="font-mono text-slate-700 font-medium">
          {{ (invoiceDetail?.chargingEnd | date: "dd/MM/yyyy HH:mm") || "--" }}
        </span>
      </div>

      <!-- Exit Date -->
      <div class="flex justify-between items-center" *ngIf="invoiceDetail?.exitAt">
        <span class="text-slate-400 font-bold">{{ currentLang === "TH" ? "เวลาออก" : "Exit Date" }}</span>
        <span class="font-mono text-slate-700 font-medium">
          {{ (invoiceDetail?.exitAt | date: "dd/MM/yyyy HH:mm") || "--" }}
        </span>
      </div>

      <!-- Overtime Duration -->
      <div class="flex justify-between items-center text-amber-600 font-bold pt-1">
        <span>{{ currentLang === "TH" ? "เวลาที่เกินกำหนด" : "Overtime Duration" }}</span>
        <span>
          <ng-container *ngIf="displayHours()">{{ displayHours() }} {{ currentLang === "TH" ? "ชม." : "hr" }}
          </ng-container>
          <ng-container *ngIf="displayMinutes()">{{ displayMinutes() }} {{ currentLang === "TH" ? "นาที" : "min"
            }}</ng-container>
          <ng-container *ngIf="!displayHours() && !displayMinutes()">--</ng-container>
        </span>
      </div>

      <!-- Fee Breakdown -->
      <div class="border-t border-dashed border-slate-200 my-1 pt-2 space-y-1">
        <div class="flex justify-between items-center text-slate-500">
          <span>{{ currentLang === "TH" ? "ค่าธรรมเนียม" : "Fee" }}</span>
          <span class="font-mono">{{ (invoiceDetail?.fee | number: "1.2-2") || "0.00" }} ฿</span>
        </div>
        <div class="flex justify-between items-center text-emerald-600" *ngIf="invoiceDetail?.discount">
          <span>{{ currentLang === "TH" ? "ส่วนลด" : "Discount" }}</span>
          <span class="font-mono">-{{ invoiceDetail?.discount | number: "1.2-2" }} ฿</span>
        </div>
      </div>

      <!-- Final Total Amount -->
      <div class="border-t border-slate-200 pt-2 flex justify-between items-center">
        <span class="text-sm font-black text-slate-800">{{ currentLang === "TH" ? "ยอดชำระสุทธิ" : "Total Pay" }}</span>
        <span class="text-lg font-black text-rose-600 font-mono">{{ (invoiceDetail?.total | number: "1.2-2") || "0.00"
          }} ฿</span>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="space-y-2 pt-2">
      <button (click)="onClickTopup()" [disabled]="!invoiceDetail?.id"
        class="w-full py-3.5 bg-amber-400 hover:bg-amber-500 text-slate-800 rounded-2xl font-black shadow-md active:scale-95 transition-all flex items-center justify-center gap-2 outline-none border-none text-xs disabled:opacity-50">
        <img src="icons/payments_black.svg" class="w-4 h-4" />
        <span>{{ currentLang === "TH" ? "ชำระเงินด้วยบัญชีเติมเงิน" : "Pay with EV Wallet" }}</span>
      </button>

      <button (click)="closeModalInvoiceDetail()"
        class="w-full py-3 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-2xl font-bold transition-all text-xs border-none outline-none">
        {{ currentLang === "TH" ? "ปิดหน้าต่าง" : "Close" }}
      </button>
    </div>

  </div>
</div>

<!-- Modal 2: Confirm Payment Topup -->
<div *ngIf="isOpenModalTopup"
  class="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/50 backdrop-blur-sm px-4 animate-fade-in">
  <div
    class="bg-white w-full max-w-sm rounded-[2.5rem] relative overflow-hidden shadow-2xl animate-scale-up border border-slate-100/50">

    <!-- Dark Gradient Modal Header -->
    <div class="bg-gradient-to-r from-slate-800 to-slate-900 p-6 text-center text-white relative">
      <button (click)="closeModalTopup()"
        class="absolute top-4 right-4 w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center border-none outline-none">
        <img src="icons/close_white.svg" class="w-4 h-4" />
      </button>

      <div
        class="w-12 h-12 rounded-2xl bg-amber-400/20 text-amber-400 flex items-center justify-center mx-auto mb-2 border border-amber-400/30">
        <img src="icons/electric_bolt_slate_dark.svg" class="w-6 h-6" />
      </div>

      <h2 class="text-base font-black text-white">
        {{ currentLang === "TH" ? "ยืนยันชำระผ่านบัญชีเติมเงิน" : "Confirm Wallet Payment" }}
      </h2>
      <p class="text-[10px] text-slate-300 mt-0.5">
        {{ currentLang === "TH" ? "ระบบจะทำการหักเงินจากบัญชีเติมเงินของคุณ" : "Amount will be deducted from your top-up
        wallet" }}
      </p>
    </div>

    <!-- Content Body -->
    <div class="p-6 space-y-4">
      <!-- Balance & Deduction Summary -->
      <div class="bg-slate-50 rounded-2xl p-3.5 space-y-2 border border-slate-100 text-xs">
        <div class="flex justify-between items-center text-slate-500">
          <span>{{ currentLang === "TH" ? "ยอดเงินคงเหลือปัจจุบัน" : "Current Balance" }}</span>
          <span class="font-mono font-bold text-slate-700">{{ topupAmount.amount | number: "1.2-2" }} ฿</span>
        </div>

        <div class="flex justify-between items-center text-rose-600 font-bold">
          <span>{{ currentLang === "TH" ? "ยอดที่ต้องชำระ" : "Deduction Amount" }}</span>
          <span class="font-mono font-black text-sm">-{{ invoiceDetail?.total | number: "1.2-2" }} ฿</span>
        </div>

        <div class="border-t border-slate-200 pt-2 flex justify-between items-center text-emerald-600 font-bold">
          <span>{{ currentLang === "TH" ? "ยอดคงเหลือหลังหัก" : "Remaining Balance" }}</span>
          <span class="font-mono font-black">{{ (topupAmount.amount - (invoiceDetail?.total || 0)) | number: "1.2-2" }}
            ฿</span>
        </div>
      </div>

      <!-- Additional Context -->
      <div class="space-y-1.5 text-xs text-slate-600 px-1">
        <div class="flex justify-between items-center">
          <span class="text-slate-400">{{ currentLang === "TH" ? "สถานที่" : "Location" }}</span>
          <span class="font-bold truncate max-w-[160px]">{{ invoiceDetail?.siteName || "--" }}</span>
        </div>
        <div class="flex justify-between items-center">
          <span class="text-slate-400">{{ currentLang === "TH" ? "รายละเอียด" : "Description" }}</span>
          <span class="font-bold">{{ invoiceDetail?.feeName || invoiceDetail?.name || "--" }}</span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="pt-2 space-y-2">
        <button (click)="paymentTopup()"
          class="w-full py-3.5 bg-amber-400 hover:bg-amber-500 text-slate-800 rounded-2xl font-black shadow-md active:scale-95 transition-all flex items-center justify-center gap-2 outline-none border-none text-xs">
          <img src="icons/check_circle_black.svg" class="w-4 h-4" />
          <span>{{ currentLang === "TH" ? "ยืนยันชำระเงิน" : "Confirm Payment" }}</span>
        </button>

        <button (click)="closeModalTopup()"
          class="w-full py-3 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-2xl font-bold transition-all text-xs border-none outline-none">
          {{ currentLang === "TH" ? "ยกเลิก" : "Cancel" }}
        </button>
      </div>
    </div>

  </div>
</div>

<!-- Outermost Loading Overlay -->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>